import http from "../http-common";
import authHeader from './auth-header';

class generalSettingsService {
  create(data) {
    return http.post("/general_settings/invalid_passwords/create", data, { headers: authHeader() });
  }

  getAllInvalidPasswords() {
    return http.get("/general_settings/invalid_passwords", { headers: authHeader() });
  }

  getSettings() {
    return http.get("/general_settings", { headers: authHeader() });
  }

  updateInvalidPasswords(id, data) {
    return http.put(`/general_settings/invalid_passwords/${id}`, data, { headers: authHeader() });
  }

  deleteInvalidPasswords(id) {
    return http.delete(`/general_settings/invalid_passwords/delete/${id}`, { headers: authHeader() });
  }

  updateSettings(id, data) {
    return http.put(`/general_settings/${id}`, data, { headers: authHeader() });
  }
}

export default new generalSettingsService();